import styled from 'styled-components'
import getBreakpoint from '@client/utils/breakpoints'

import { H6 } from '@components/Text'

export const LocationButton = styled.section`
  display: flex;
  align-items: center;
  cursor: pointer;
`
export const Icon = styled.img`
  width: 20px;
  height: 20px;

  @media (min-width: ${getBreakpoint('xl')}px) {
    width: 24px;
    height: 24px;
  }
`

export const Text = styled(H6)`
  margin-left: 8px;
  font-weight: 700;
  text-transform: capitalize;
`

export const ArrowDown = styled.span`
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid var(--paris-50);
  margin-left: 4px;
`
